import { render } from "./name-only.vue?vue&type=template&id=ed64c986&scoped=true"
import script from "./name-only.vue?vue&type=script&lang=js"
export * from "./name-only.vue?vue&type=script&lang=js"

import "./name-only.vue?vue&type=style&index=0&id=ed64c986&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed64c986"]])

export default __exports__